import {
  Box,
  Button,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useApi from "../../../hooks/useApi";

// "Canciones de {artista}": el material de una ficha del roster, dentro de
// su propia ficha. El botón de subir lleva el artista en la URL, así que la
// atribución la resuelve el contexto de la pantalla y no un selector que el
// sello pueda equivocar al cargar a las apuradas.
export default function CancionesDelArtista({ artista, showSnack }) {
  const { loadApi } = useApi();
  const [canciones, setCanciones] = useState([]);
  const [cargando, setCargando] = useState(true);

  const cargar = useCallback(() => {
    setCargando(true);
    loadApi(
      `artista/canciones?managed_artist_id=${artista.id}`,
      true,
      "get"
    )
      .then((res) => setCanciones(res.data || []))
      .catch((e) => showSnack(e.message, "error"))
      .finally(() => setCargando(false));
  }, [artista.id]);

  useEffect(() => {
    cargar();
  }, [cargar]);

  return (
    <Card sx={{ mt: 2 }}>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          gap={1}
        >
          <Typography variant="h6" fontWeight={700}>
            Canciones de {artista.nombre}
          </Typography>
          {/* Una ficha dada de baja no recibe material nuevo. */}
          {artista.activo && (
            <Button
              variant="outlined"
              component={Link}
              to={`/artista/nueva?artista=${artista.id}`}
            >
              + Subir canción
            </Button>
          )}
        </Stack>

        {!cargando && canciones.length === 0 && (
          <Typography variant="body2" color="text.secondary" mt={2}>
            Todavía no le subiste ninguna canción a {artista.nombre}.
          </Typography>
        )}

        <Box
          sx={{
            mt: 2,
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
            gap: 2,
          }}
        >
          {canciones.map((cancion) => (
            <Stack
              key={cancion.id}
              component={Link}
              to={`/artista/cancion/${cancion.id}`}
              spacing={1}
              sx={{ textDecoration: "none", color: "inherit" }}
            >
              <Box
                component="img"
                src={cancion.url_img}
                alt={cancion.nombre}
                sx={{
                  width: "100%",
                  aspectRatio: "1",
                  objectFit: "cover",
                  borderRadius: 2,
                }}
              />
              <Typography variant="body2" fontWeight={600} noWrap>
                {cancion.nombre}
              </Typography>
              <Typography variant="caption" color="text.secondary" noWrap>
                {cancion.genero}
              </Typography>
            </Stack>
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
